const NEWS_FIELDS = `
  items {
    ItemId
    CreatedDate
    CreatedBy
    IsDeleted
    Tags
    Title
    Content
    attachmentUrls {
      id
      name
      size
      url
      mimeType
    }
    authorSnapshot {
      firstName
      lastName
      email
      profileImageUrl
    }
    coverImageUrl
    categoryIds
    isDraft
    isPinned
  }
`;

export const GET_NEWS = `
  query GetNews(
    $where: newsFilterInput
    $order: [DynamicSortInput!]
    $pageSize: Int!
    $pageNo: Int!
  ) {
    getnewss(
      where: $where
      order: $order
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      totalCount
      ${NEWS_FIELDS}
    }
  }
`;

export const GET_NEWS_ITEM = `
  query GetNewsItem($where: newsFilterInput) {
    getnewss(where: $where, paging: { pageNo: 1, pageSize: 1 }) {
      ${NEWS_FIELDS}
    }
  }
`;

// NOTE: no call sites — converted for consistency only.
export const GET_ALL_CATEGORIES = `
  query GetAllCategories($where: categoryFilterInput) {
    getcategorys(where: $where, paging: { pageNo: 1, pageSize: 1000 }) {
      items {
        ItemId
        categoryName
        Tags
      }
    }
  }
`;

export const DELETE_NEWS = `
  mutation DeleteNews($itemId: String!) {
    deletenews(
      where: { ItemId: { eq: $itemId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every news item created by a user (used by the user-deletion purge).
export const DELETE_MANY_NEWS_BY_CREATOR = `
  mutation DeleteManyNewsByCreator($createdBy: String!) {
    deleteManynews(
      where: { CreatedBy: { eq: $createdBy } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;

export const CREATE_NEWS = `
  mutation CreateNews($input: newsInsertInput!) {
    insertnews(input: $input) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_NEWS = `
  mutation UpdateNews($itemId: String!, $input: newsUpdateInput!) {
    updatenews(where: { ItemId: { eq: $itemId } }, input: $input) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk update: refresh the author snapshot on every article by this user after
// a profile edit (used by user-name-snapshot-sync).
export const UPDATE_MANY_NEWS_AUTHOR_SNAPSHOT = `
  mutation UpdateManyNewsAuthorSnapshot(
    $createdBy: String!
    $firstName: String
    $lastName: String
    $email: String
    $profileImageUrl: String
  ) {
    updateManynews(
      where: { CreatedBy: { eq: $createdBy } }
      input: {
        authorSnapshot: {
          firstName: $firstName
          lastName: $lastName
          email: $email
          profileImageUrl: $profileImageUrl
        }
      }
    ) {
      acknowledged
      totalImpactedData
      message
    }
  }
`;
